export default __webpack_public_path__ + "resources/icons/d441-e5b8.png";